export const TRACKED_PRODUCT_STATUS_FOUND = 1;
export const TRACKED_PRODUCT_STATUS_TEXT_FOUND = 'found';
export const TRACKED_PRODUCT_STATUS_EXTRA = 2;
export const TRACKED_PRODUCT_STATUS_TEXT_EXTRA = 'extra';
export const TRACKED_PRODUCT_STATUS_MISSING = 3;
export const TRACKED_PRODUCT_STATUS_TEXT_MISSING = 'missing';
export const TRACKED_PRODUCT_STATUS_MOVED = 4;
export const TRACKED_PRODUCT_STATUS_TEXT_MOVED = 'moved';
export const SCAN_RACK_COMP = 'SCAN_RACK_COMP';
export const MOVE_TO_LOST_AND_FOUND_DESTINATION_TYPE = 'MOVE_TO_LOST_AND_FOUND_DESTINATION_TYPE';
